import RevFFrame from "../static/images/revf/rev_f_software_small.webp";
import { DISTANT_HERO } from "./ProductHeroes";
import DaveDavidsonFrame from "../static/images/TSDD/plugin/cobalt.webp";
import BassDistantFrame from "../static/images/distant_bass_suite/plugin-hero.webp";
import MonsterFuzzFrame from "../static/images/protone/Monster.webp";
import DeadHorseFrame from "../static/images/protone/Deadhorse.webp";
import CorMidBoostFrame from "../static/images/protone/Cor.webp";

export const PRODUCT_NAMES = {
  "ecocide-amplifier-suite": "ToneSuite - Ecocide",
  "distant-amplifier-suite": "ToneSuite - Distant",
  "rev-f-amplifier-suite": "AmpSuite - Rev F",
  "dd-amplifier-suite": "ToneSuite - Dave Davidson",
  "distant-bass-suite": "BassSuite - Distant",
  "protone-monsterfuzz": "Pro Tone Pedals - Monster Fuzz",
  "protone-deadhorse": "Pro Tone Pedals - Dead Horse Overdrive",
  "protone-midboost": "Pro Tone Pedals - Cor Mid Boost",
  "namu-amplifier-suite": "NAM Universal",
  "forte-boost-22": "Forte Boost 22",
  "x-drive-pedal": "X-Drive",
  "resington-shoeless-drive": "Resington Shoeless Drive",
  "cab-suite-412-os-lite": "Cab Suite 412 OS Lite"
}

export const PRODUCT_IMAGES = {
  "rev-f-amplifier-suite": RevFFrame,
  "distant-amplifier-suite": DISTANT_HERO.src,
  "dd-amplifier-suite": DaveDavidsonFrame,
  "distant-bass-suite": BassDistantFrame,
  "protone-monsterfuzz": MonsterFuzzFrame,
  "protone-deadhorse": DeadHorseFrame,
  "protone-midboost": CorMidBoostFrame,
}
